"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _checkHTML = _interopRequireDefault(require("../string/checkHTML"));
var _staticContent = _interopRequireDefault(require("./staticContent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var staticContentPropCheck = function staticContentPropCheck(props, propName, componentName) {
  var propValue = props[propName];
  var valueToCheck = Array.isArray(propValue) && typeof propValue[0] === 'string' ? propValue[0] : propValue;
  if (typeof valueToCheck !== 'string') {
    return null;
  }
  if ((0, _checkHTML.default)(valueToCheck)) {
    return new Error("String containing markup provided as prop \"".concat(propName, "\" to ").concat(componentName, ". ").concat(componentName, " will no longer parse markup. See the migration guide for more info https://gitlab.com/JohnLewisPartnership/jl-ui/jl-ui-kit/-/blob/main/migration.md#migrating-from-29-to-30"));
  }
  try {
    _staticContent.default.get(valueToCheck);
  } catch (e) {
    return null;
  }
  return new Error("Static content key \"".concat(valueToCheck, "\" provided as prop \"").concat(propName, "\" to ").concat(componentName, ". ").concat(componentName, " will no longer convert static content keys. See the migration guide for more info https://gitlab.com/JohnLewisPartnership/jl-ui/jl-ui-kit/-/blob/main/migration.md#migrating-from-29-to-30"));
};
var requiredStaticContentPropCheck = function requiredStaticContentPropCheck(props, propName, componentName) {
  var propValue = props[propName];
  if (typeof propValue === 'undefined') {
    return new Error("Missing required \"".concat(propName, "\" prop in ").concat(componentName, " component"));
  }
  return staticContentPropCheck(props, propName, componentName);
};
staticContentPropCheck.isRequired = requiredStaticContentPropCheck;
var _default = exports.default = staticContentPropCheck;